import { RateType } from '@/gql/graphql'
import { $t } from '@/composables/translation'

/** Hour/day/week/month labels shared by every rate-type-aware unit display. */
export const durationRateTypeUnitLabels = (): Partial<Record<RateType, string>> => ({
  [RateType.Hourly]: $t('hour'),
  [RateType.Daily]: $t('day'),
  [RateType.Weekly]: $t('week'),
  [RateType.Monthly]: $t('month'),
})
